export default "__VITE_ASSET__DNu1gefI__"